import qs from 'qs';

export const useQueryParams = (): qs.ParsedQs => {
  return qs.parse(location.search, { ignoreQueryPrefix: true });
};
